module.exports = __webpack_public_path__ + "img/all-dots-917.fd32f09b.svg";